import React from 'react';
const Instructions = () => {
  return <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-8" data-id="element-17">
      <h3 className="text-xl font-semibold text-blue-800 mb-4" data-id="element-18">
        🎯 Instructions
      </h3>
      <ul className="text-blue-800 space-y-2 list-inside list-disc" data-id="element-19">
        <li data-id="element-20">
          <strong data-id="element-21">Answer honestly</strong> based on your natural tendencies and
          long-term patterns
        </li>
        <li data-id="element-22">
          <strong data-id="element-23">Choose the option</strong> that most closely describes you,
          even if it's not perfect
        </li>
        <li data-id="element-24">
          <strong data-id="element-25">Think about</strong> how you are most of the time, not just
          recently
        </li>
        <li data-id="element-26">
          <strong data-id="element-27">Don't overthink</strong> - go with your first instinct
        </li>
        <li data-id="element-28">
          This assessment reveals your <strong data-id="element-29">dominant element(s)</strong> and
          constitutional patterns
        </li>
      </ul>
    </div>;
};
export default Instructions;